import React, { useState, useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";

import Get from "../../api/Get";
import Post from "../../api/Post";
import { COMPANY_ALL } from "../../api/Routes";
import { COMPANY_ADD } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import CompanyList from "./company/CompanyList";
import AddCompany from "./company/AddCompany";
import Filtro from "../../components/catalogos/Filtro";
import LoadingList from "../../loader/LoadingList";
import "../../styles/catalogos/catalogos.css";
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever";

function CompanyIndex() {
  //Parametros para actualizar la tabla
  const [items, setItems] = useState([]);
  const [initialValues, setInitialValues] = useState({
    name: "",
    telephone: "",
  });
  const [loading, setLoading] = useState(false);
  const [loadData, setLoadData] = useState(true);

  const [showModalError, setShowModalError] = useState(false);
  const [errorServer, setErrorServer] = useState(null);
  const handleClose = () => setShowModalError(false);

  //Token de autentificación para los servicios
  const { auth } = useContext(authContext);
  let accesToken = auth.data.access_token;

  useEffect(() => cargarCompanias(), []);

  const cargarCompanias = () => {
    setLoading(true);
    let mounted = true;
    Get({ url: COMPANY_ALL, access_token: accesToken })
      .then((resp) => {
        if (mounted) {
          setItems(resp.data.data.response.content);
          setLoading(false);
        }
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
        setLoading(false);
      });
    return () => (mounted = false);
  };

  const agregarCompania = (values) => {
    values.active = "true";
    setLoading(true);

    setTimeout(() => {
      Post({
        url: COMPANY_ADD,
        data: values,
        header: true,
        access_token: accesToken,
      })
        .then((response) => {
          setInitialValues({ name: "" });
          setLoadData(!loadData);
          setLoading(false);
          toast.success("Compañia creada");
        })
        .catch((error) => {
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
          setLoading(false);
        });
    }, 1000);
  };

  const editarCompania = (values) => {
    Post({
      url: COMPANY_ADD,
      data: values,
      header: true,
      access_token: accesToken,
    })
      .then((response) => {
        //cargarCompanias()
        //toast.success("Cambios guardados")
      })
      .catch((error) => {
        setLoading(false);
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
  };

  return (
    <>
      {loading && <LoadingList texto="" />}

      <div className="body">
        <Filtro catName="Compañias" />
        <Row>
          <Col xs="6" md="6">
            {!loading && (
              <AddCompany
                agregarCompania={agregarCompania}
                initialValues={initialValues}
              />
            )}
          </Col>
          <Col xs="6" md="6">
            <CompanyList
              items={items}
              editarCompania={editarCompania}
              accesToken={accesToken}
            />
          </Col>
        </Row>
      </div>
      <ComponentModalErrorSever
        show={showModalError}
        handleClose={handleClose}
        error={errorServer}
      />
    </>
  );
}

export default CompanyIndex;
